import { useCallback } from "react"

import { IconButton, InputAdornment } from "@mui/material"
import { useField, useFormikContext } from "formik"

import { CloseIcon } from "@l2r-front/l2r-icons"

import { DatePicker } from "../../components/DatePicker"

export const FormikDatePicker = (props) => {

    const {
        onChange,
        ...datePickerProps
    } = props

    const [fieldProps, metaProps] = useField(props)
    const { setStatus, setFieldValue } = useFormikContext()

    const handleChange = useCallback((value) => {
        setFieldValue(props.name, value)
        setStatus()
        onChange?.(value)
    }, [props, onChange, setFieldValue, setStatus])

    return <DatePicker
        {...datePickerProps}
        {...fieldProps}
        {...((metaProps.error && metaProps.touched) ? {
            error: true,
            helperText: metaProps.error,
        } : {})}
        disableOpenPicker
        onChange={handleChange}
        slotProps={{
            textField: {
                InputProps: {
                    endAdornment: fieldProps?.value ? (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setFieldValue(props.name, null)
                                }}
                                edge="end"
                                size="small"
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                },
            },
        }}
    />
}